import { getColor } from '../utils';

import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const SMSBounce = ({
  height = 24,
  width = 24,
  color = 'currentColor',
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon width={width} height={height} viewBox="0 0 24 24" {...props}>
    <path
      d="M9.16725 17.925L5.8125 20.4375V17.0625H4.6875C4.38913 17.0625 4.10298 16.944 3.892 16.733C3.68103 16.522 3.5625 16.2359 3.5625 15.9375V4.6875C3.5625 4.38913 3.68103 4.10298 3.892 3.892C4.10298 3.68103 4.38913 3.5625 4.6875 3.5625H19.3125C19.6109 3.5625 19.897 3.68103 20.108 3.892C20.319 4.10298 20.4375 4.38913 20.4375 4.6875V10.3125"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 14C10.8678 14.3047 13.0579 15.1994 13.3902 16.5508"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeDasharray="2 2"
    />
    <path
      d="M16 15.8999C15.3987 16.4975 14.4675 17.7431 14.6582 19.2465"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeDasharray="2 2"
    />
    <circle
      cx="18"
      cy="13.3999"
      r="1.35"
      fill="white"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.3"
    />
  </SvgIcon>
);
